import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}

// Overview hero's second benefit bullet ("the Live Update pins your brand to
// their homescreen") — the Sketch prototype uses a thumbtack glyph there.
const Pushpin = ({ className = '', fillColor = 'currentColor' }: PropsT) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2h6a1 1 0 010 2 1 1 0 00-1 1v3.63a2 2 0 001.11 1.79l1.48.74A2 2 0 0115.7 13H4.3a2 2 0 011.11-1.84l1.48-.74A2 2 0 008 8.63V5a1 1 0 00-1-1 1 1 0 010-2zm2 12h2v4H9v-4z"
      fill={fillColor}
    />
  </svg>
)

export default Pushpin
